import { call, put, takeEvery } from "redux-saga/effects";
import { chuyenNganhApi } from "../../../api/category/chuyenNganhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IDmChuyenNganh } from "../../../model/respone/category/IDmChuyenNganh";
import {
  eDmChuyenNganhActionIds,
  IDmChuyenNganhActionTypes,
} from "../../action-types/category/IDmChuyenNganhActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.chuyenNganh;
export function* chuyenNganhSaga(): any {
  yield takeEvery(eDmChuyenNganhActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmChuyenNganhActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmChuyenNganhActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(chuyenNganhApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.chuyenNganh.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.chuyenNganh.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
function* saveWorker(action: IDmChuyenNganhActionTypes): any {
  let res: IBaseRespone = yield call(chuyenNganhApi.SelectAll);
  let payload = action.payload as IDmChuyenNganh;
  if (payload.id_chuyen_nganh > 0) {
    res = yield call(chuyenNganhApi.Update, payload);
  } else {
    res = yield call(chuyenNganhApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IDmChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(
    chuyenNganhApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
